import React from 'react';

const DisclaimerSvg = ({ width = 149, height = 149, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 149 149"
      fill="none"
      {...props}
    >
      <g opacity="0.62" filter="url(#filter0_f_9389_31995)">
        <circle cx="74.5" cy="74.5" r="71.5" fill="#E6E6E6" />
      </g>

      <g filter="url(#filter1_i_9389_31995)">
        <path
          d="M67.345 20.354C70.4057 14.9276 78.2205 14.9276 81.2811 20.354L123.281 94.8177C126.289 100.151 122.436 106.748 116.313 106.748H32.3133C26.1906 106.748 22.3374 100.151 25.3453 94.8177L67.345 20.354Z"
          fill="#FFA525"
        />
      </g>

      <g filter="url(#filter2_di_9389_31995)">
        <path
          d="M66.9492 43.3667C66.9492 39.0285 70.466 35.5117 74.8043 35.5117C79.1425 35.5117 82.6593 39.0285 82.6593 43.3667V63.6567C82.6593 67.9949 79.1425 71.5117 74.8043 71.5117C70.466 71.5117 66.9492 67.9949 66.9492 63.6567V43.3667Z"
          fill="#995A00"
        />
      </g>

      <path
        d="M68.9492 46.0117C68.9492 44.631 70.0685 43.5117 71.4492 43.5117C72.8299 43.5117 73.9492 44.631 73.9492 46.0117V53.0117C73.9492 54.3924 72.8299 55.5117 71.4492 55.5117C70.0685 55.5117 68.9492 54.3924 68.9492 53.0117V46.0117Z"
        fill="white"
      />

      <g filter="url(#filter3_di_9389_31995)">
        <path
          d="M66.9492 89.3667C66.9492 85.0285 70.466 81.5117 74.8043 81.5117C79.1425 81.5117 82.6593 85.0285 82.6593 89.3667V89.6567C82.6593 93.9949 79.1425 97.5117 74.8043 97.5117C70.466 97.5117 66.9492 93.9949 66.9492 89.6567V89.3667Z"
          fill="#995A00"
        />
      </g>

      <path
        d="M40.193 76.941C40.8706 75.7666 42.3717 75.3643 43.5458 76.0427C44.7198 76.721 45.1223 78.223 44.4447 79.3974L41.0072 85.3554C40.3296 86.5299 38.8285 86.9321 37.6545 86.2538C36.4804 85.5755 36.078 84.0735 36.7556 82.899L40.193 76.941Z"
        fill="white"
      />

      <defs>
        <filter
          id="filter0_f_9389_31995"
          x="0"
          y="0"
          width="149"
          height="149"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_9389_31995" />
        </filter>

        <filter
          id="filter1_i_9389_31995"
          x="24.3018"
          y="16.2842"
          width="100.023"
          height="90.4639"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-16" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.588235 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_9389_31995" />
        </filter>

        <filter
          id="filter2_di_9389_31995"
          x="66.9492"
          y="35.5117"
          width="18.71"
          height="39"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9389_31995" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9389_31995" result="shape" />
          <feOffset dx="-5" dy="-5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_9389_31995" />
        </filter>

        <filter
          id="filter3_di_9389_31995"
          x="66.9492"
          y="81.5117"
          width="18.71"
          height="19"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9389_31995" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9389_31995" result="shape" />
          <feOffset dx="-5" dy="-5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_9389_31995" />
        </filter>
      </defs>
    </svg>
  );
};

export default DisclaimerSvg;
